import styled from '@emotion/styled'

import Badge from '@segment/matcha/components/Badge'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import stateAssetPng from '../assets/State.png'
import twilioAssetPng from '../assets/Twilio.png'

const cards = [
  {
    img: stateAssetPng,
    imgAlt: `Illustration: 2021 State of Customer Engagement report`,
    badge: `Report`,
    title: `2021 State of Customer Engagement report`,
    content: `2020 transformed the way we communicate. Check out the State of Customer Engagement report to explore five trends defining digital engagement in 2021.`,
    url: `https://www.twilio.com/state-of-customer-engagement/`,
  },
  {
    img: twilioAssetPng,
    imgAlt: `Illustration: Leading brands are building with Twilio`,
    badge: `Customer Story`,
    title: `Leading brands are building with Twilio`,
    content: `Explore what 200,000+ of your peers, from startups to global enterprises, have built with Twilio.`,
    url: `https://customers.twilio.com/`,
  },
]
const Cards = () => {
  return (
    <Wrapper>
      <ColumnTrack columns={1} overrides={{ md: 2 }} gap="small">
        {cards.map((card) => (
          <StyledCardBase key={card.title} href={card.url}>
            <Card.Image src={card.img} alt={card.imgAlt} />
            <Card.Body>
              <Card.Accessories>
                <Card.AccessoriesRow>
                  <Badge variant="outlined">{card.badge}</Badge>
                </Card.AccessoriesRow>
              </Card.Accessories>
              <Card.Copy>
                <Card.Headline tag="h3">{card.title}</Card.Headline>
                <Card.Description variant="pLarge">{card.content}</Card.Description>
              </Card.Copy>
              <Card.Action alignment="right">
                <ChevronRightIcon />
              </Card.Action>
            </Card.Body>
          </StyledCardBase>
        ))}
      </ColumnTrack>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 960px;
`

const StyledCardBase = styled(CardBase)`
  max-width: 464px;
  display: flex;
  flex-direction: column;
`

export default Cards
